import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Text, Flex, Image } from "@chakra-ui/react";
import WhatsHappeningCardDetailsBottomSheet from "./WhatsHappeningCardDetailsBottomSheet";
import { IMG_URL } from "../common/Constant";
const WhatsHappeningCard = ({ happening, }) => {
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    const formatTime = (timeString) => {
        if (!timeString)
            return "";
        const date = new Date(timeString);
        return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };
    const formatDate = (dateString) => {
        if (!dateString)
            return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
        });
    };
    const formatDateRange = (startTime, endTime) => {
        if (!startTime)
            return "";
        const startDate = new Date(startTime);
        const endDate = endTime ? new Date(endTime) : null;
        if (!endDate || startDate.toDateString() === endDate.toDateString()) {
            // Single day
            return startDate.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
            });
        }
        else {
            // Multiple days
            const startDay = startDate.toLocaleDateString("en-GB", {
                day: "2-digit",
            });
            const endDay = endDate.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
            });
            return `${startDay} - ${endDay}`;
        }
    };
    const formatTimeRange = (startTime, endTime) => {
        if (!startTime)
            return "";
        const startTimeFormatted = formatTime(startTime);
        const endTimeFormatted = endTime ? formatTime(endTime) : "";
        if (endTimeFormatted) {
            return `${startTimeFormatted} - ${endTimeFormatted}`;
        }
        return startTimeFormatted;
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { minW: "138px", maxW: "138px", height: "160px", my: 3, bg: "#2C2C2C", borderRadius: "16px", border: "1px solid #A383FF", p: "16px", cursor: "pointer", display: "flex", flexDirection: "column", justifyContent: "space-between", onClick: () => setIsDetailsOpen(true), children: [_jsxs(Flex, { alignItems: "center", children: [_jsx(Image, { src: `${IMG_URL}/icons/mdi_calendar.png`, alt: "Calendar", width: "20px", height: "20px", mr: 1 }), _jsx(Text, { fontSize: "12px", color: "white", fontWeight: "700", children: happening.date ||
                                    formatDateRange(happening.startTime || happening.start_time, happening.endTime || happening.end_time) })] }), _jsxs(Box, { height: "78px", width: "106px", children: [_jsx(Text, { fontSize: "12px", fontWeight: "600", color: "white", mt: 15, lineHeight: "18px", height: "54px", gap: "2px", children: happening.title }), (happening.startTime ||
                                happening.start_time ||
                                happening.endTime ||
                                happening.end_time) && (_jsx(Text, { fontSize: "10px", color: "#E0E0E0", fontWeight: "500", children: formatTimeRange(happening.startTime || happening.start_time, happening.endTime || happening.end_time) }))] })] }), _jsx(WhatsHappeningCardDetailsBottomSheet, { isOpen: isDetailsOpen, onClose: () => setIsDetailsOpen(false), happening: happening })] }));
};
export default WhatsHappeningCard;
